const highlightMixin = {
    methods:{
        getHighlightFilename(file,slugname){
             let slug_name = slugname;
            if(file && Object.prototype.hasOwnProperty.call(file,'highlight') && Object.prototype.hasOwnProperty.call(file.highlight,'slug_name')){
                slug_name = file.highlight.slug_name.join('');
                return {highlight:true,filename:slugname, slugname:slug_name};
            }
            // else if(file && Object.prototype.hasOwnProperty.call(file,'highlight') && Object.prototype.hasOwnProperty.call(file.highlight,'file_name')){
            //     return {highlight:true,filename:file.highlight.file_name.join(''), slugname:slug_name}
            // }
            return {highlight:false,filename:slugname, slugname:slug_name};
         },
         getMatchedDetailsHighlight(file){
           if(file && Object.prototype.hasOwnProperty.call(file,'highlight')){
                let spacingBetweenEachHighlight = 10; 
                let excludeList =  ['file_name','slug_name'],  highlightWrapper = '<span>';
                let spacingTemplate = `<span style="display:inline-block;width:${spacingBetweenEachHighlight}px;height:1px;"></span>`;

                 for(let key in file.highlight){
                     if(excludeList.indexOf(key) == -1 && key !== 'metadata.tag_values'){
                        highlightWrapper += file.highlight[key].map((text) => text + spacingTemplate).join("")
                     }

                    if(excludeList.indexOf(key) == -1 && key == 'metadata.tag_values'){
                        let tagsWrapper = '<ul class="p-0 ml-0" style="display:inline-block;list-style:none;">';
                        for(let i = 0; i < file.highlight['metadata.tag_values'].length; i++){
                            tagsWrapper += `<li style="padding-inline-start: 0px !important" class="view-tags">
                                               <span>${file.highlight['metadata.tag_values'][i]}</span>
                                            </li>`
                        }
                        tagsWrapper += '</ul>' + spacingTemplate;
                        highlightWrapper += tagsWrapper;
                    }

                    console.log('[key..............]',key);

                    if(excludeList.indexOf(key) == -1 && key == 'files.ai_info.transcript.content'){
                        let transcriptContentHighlight = file.highlight[key].map(el => `<span class="transcript-content-highlight">${el}</span>`).join('');
                        highlightWrapper += transcriptContentHighlight;
                    }
                    if(excludeList.indexOf(key) == -1 && key == 'files.ai_info.ocr.script'){
                        let ocrContentHighlight = file.highlight[key].map(el => `<span class="transcript-content-highlight">${el}</span>`).join('');
                        highlightWrapper += ocrContentHighlight;
                    }
                 }
              return  highlightWrapper + '</span>'
           }
           return '';
        },
    }
}


export default highlightMixin;